import { BaseComponent } from '../../base-component';

export type ChangeImageEvent = {
    index: number;
    emitter: ImagesSubComponent;
};

export abstract class ImagesSubComponent extends BaseComponent {
    constructor() {
        super();
        o_global.eventQBus.on('ft5.pdp-images.changeImage', (data: ChangeImageEvent) => {
            if (data.emitter !== this) {
                this.onImageChanged(data.index);
            }
        });
    }

    protected abstract onImageChanged(index: number): void;

    protected changeImage(index: number) {
        const changeImageEvent: ChangeImageEvent = {
            index,
            emitter: this,
        };
        o_global.eventQBus.emit('ft5.pdp-images.changeImage', changeImageEvent);
    }
}
